import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";
//* fuck
// import Hambarger from "jsdc-dui/dist/components/Icons/Hamburger"

//TODO: EVENT_ID
const EVENT_ID = "m0008";

//TODO: aboutWalkContent
const aboutWalkContent = `「凍頂烏龍茶」乃指凍頂茶區製作的烏龍茶。凍頂烏龍茶是台灣中部的名茶，是台灣1980、90年代最著名的茶品。凍頂是地名，位於南投鹿谷鄉。台灣北部的文山包種、東方美人、鐵觀音；中部的凍頂式烏龍茶或高山茶，都習稱「部分發酵茶」（不過實際的化學變化應是「氧化」而非「發酵」），和不發酵的綠茶及全發酵的紅茶相較，部分發酵茶製茶工序最繁複，也最需要有經驗的茶師製作。全世界製造部分發酵茶的地方，主要就是台灣、福建與廣東。
製作部分發酵茶非常重要的是師傅經驗性的工藝。所謂的「烏龍茶」，不是用青心烏龍茶種做出來就叫做烏龍茶，包種茶、烏龍茶、鐵觀音等不同風味的茶，乃是師傅精準控制茶葉發酵度，並掌握各階段工序的細節而獲得；換句話說，我們可以同一種茶菁利用不同工序與發酵度的掌握做出台灣各種特色茶，不過有些茶樹品種特別適合做某些茶品，例如青心烏龍就特別適合做出高香味的包種及凍頂烏龍茶。
凍頂烏龍茶通常製作成球形，並烘焙成特殊的熟火香味。今天，鹿谷鄉農會舉辦之凍頂式烏龍茶比賽是全國最大場，春、冬兩季比賽常吸引超過6千點（茶樣）參加。`;

const credit = `
<div>
     團隊介紹：中研院民族所台灣茶區GIS建置計畫，聯絡電話(02)26523400
    <br>
    <br>本圖臺是由中研院民族所及智紳數位文化事業有限公司共同協力建置：
    <br>
    <br>1. 圖臺內容：中研院民族所台灣茶區GIS建置計畫
    <br>
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>
    <br>除另有聲明外，本網站內容採用創用 CC 姓名標示-非商業性-相同方式分享4.0授權條款授權公眾使用，您可以依授權條款複製、引用、轉載，唯請於合理位置標示本站網址：中研院民族所台灣茶區GIS建置計畫
    <br><a href="https://www.ntpc.edu.tw/" target="_blank" style="color: #90a011">https://www.ntpc.edu.tw/</a>
</div>	
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [{ county: "南投縣", town: "鹿谷鄉" }], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#90a011", //TODO: theme
    "--dui-accent": "#3c8932", //TODO: 數位集章按鈕顏色
    "--dui-secondary": "#90a011", //TODO: theme
    "--dui-bg-secondary": "#C9B189", // Dialog background
    "--dui-bg-accent": "#315739", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線、面都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
      language="zh-TW"
      // ! 左側數位集章選項
      // mainMenuChildren={
      //   <MenuItemWithDialog
      //     Icon={Checkin}
      //     title="路線顏色"
      //     active={dui.activeMenuId === "數位集章"}
      //     {...dui.menuSwitcherAction("數位集章")}
      //   >
      //     {/* {dui.activeMenuId === "數位集章" && (
      //     <iframe
      //       style={{ height: "100%", border: 0, borderRadius: "5px" }}
      //       src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
      //     ></iframe>
      //   )} */}
      //     {paths.map((path) => (
      //       <div
      //         key={path.name}
      //         style={{
      //           display: "flex",
      //           alignItems: "center",
      //           margin: "20px",
      //         }}
      //       >
      //         <div
      //           style={{
      //             width: "50px",
      //             height: "5px",
      //             backgroundColor: path.color,
      //             alignItems: "center",
      //             marginRight: "10px",
      //           }}
      //         ></div>
      //         <span
      //           style={{
      //             fontSize: "20px",
      //             color: "#000",
      //             // fontWeight: "bold",
      //           }}
      //         >{` ：${path.name}`}</span>
      //       </div>
      //     ))}
      //   </MenuItemWithDialog>
      // }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(23.76092, 120.7235191),
        latLng(23.7212104, 120.8163645)
      ),
      maxZoom: 20,
    })
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider Jsdc={Jsdc} config={config}>
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
